import React from 'react';
import moment from 'moment';
import { Select, SelectOption } from '../../../../components/ui';
import { Divider, Row, Spin } from 'antd';
import { PercentageItem } from '../../../Performance/CSV/CSVSummary';
import { useGetTemplatesMetricsByIdAndDateRange } from '../../../../query/mail';
import ClicksItem from './ClicksItem';

type Props = {
  templateId: string,
};

const dateFormat = 'YYYY-MM-DD';

const dateRangeConfigs = [
  {
    id: 1,
    title: 'Yesterday',
    fromDate: moment()
      .subtract(1, 'day')
      .format(dateFormat),
    toDate: moment().format(dateFormat),
  },
  {
    id: 2,
    title: 'Last 7 days',
    fromDate: moment()
      .subtract(7, 'days')
      .format(dateFormat),
    toDate: moment().format(dateFormat),
  },
  {
    id: 3,
    title: 'Last month',
    fromDate: moment()
      .subtract(1, 'month')
      .startOf('month')
      .format(dateFormat),
    toDate: moment()
      .subtract(1, 'month')
      .endOf('month')
      .format(dateFormat),
  },
  {
    id: 4,
    title: 'This month',
    fromDate: moment()
      .startOf('month')
      .format(dateFormat),
    toDate: moment()
      .endOf('month')
      .format(dateFormat),
  },
  {
    id: 5,
    title: 'Last year',
    fromDate: moment()
      .subtract(1, 'year')
      .startOf('year')
      .format(dateFormat),
    toDate: moment()
      .subtract(1, 'year')
      .endOf('year')
      .format(dateFormat),
  },
  {
    id: 6,
    title: 'This year',
    fromDate: moment()
      .startOf('year')
      .format(dateFormat),
    toDate: moment()
      .endOf('year')
      .format(dateFormat),
  },
  {
    id: 7,
    title: 'Lifetime',
    fromDate: '1970-01-01',
    toDate: moment().format(dateFormat),
  },
];

export default function TemplateMetricsModal(props: Props) {
  const [selectedDate, setSelectedDate] = React.useState(dateRangeConfigs[1]);
  const [fromDate, setFromDate] = React.useState(selectedDate.fromDate);
  const [toDate, setToDate] = React.useState(selectedDate.toDate);
  const { isLoading, data } = useGetTemplatesMetricsByIdAndDateRange(
    props.templateId,
    fromDate,
    toDate,
  );
  const {
    bounceCount,
    delivered,
    reply,
    sent,
    spamCount,
    totalClick,
    totalOpen,
    uniqueClick,
    uniqueOpen,
    unsubscriptionCount,
  } = data || {};
  return (
    <div>
      <Select
        value={selectedDate.id}
        onChange={id => {
          const selected = dateRangeConfigs.find(e => e.id === id);
          if (selected) {
            setSelectedDate(selected);
            setFromDate(selected.fromDate);
            setToDate(selected.toDate);
          }
        }}
      >
        {dateRangeConfigs.map(configs => (
          <SelectOption key={configs.id} value={configs.id}>
            {configs.title}
          </SelectOption>
        ))}
      </Select>
      <Spin spinning={isLoading}>
        <Row gutter={10} style={{ marginTop: 40 }}>
          <PercentageItem noPercentage title="Sent" value={Number(sent)} />
          <PercentageItem
            title="Deliveries"
            total={Number(sent)}
            value={Number(delivered)}
          />
          <PercentageItem
            title="Replies"
            total={Number(sent)}
            value={Number(reply)}
          />
          <PercentageItem
            noPercentage
            title="Opens"
            total={Number(sent)}
            value={Number(totalOpen)}
          />
          <PercentageItem
            title="Opens (uniq)"
            total={Number(sent)}
            value={Number(uniqueOpen)}
          />
          <ClicksItem
            fromDate={fromDate}
            sent={Number(sent)}
            templateId={props.templateId}
            toDate={toDate}
            totalClick={Number(totalClick)}
          />
          <PercentageItem
            title="Clicks (uniq)"
            total={Number(sent)}
            value={Number(uniqueClick)}
          />
        </Row>
        <Divider style={{ margin: 1, padding: 0 }} />
        <Divider style={{ margin: 1, padding: 0 }} />
        <Row gutter={10} style={{ marginTop: 20 }}>
          <PercentageItem
            title="Spam Report"
            total={Number(sent)}
            value={Number(spamCount)}
          />
          <PercentageItem
            title="Bounce"
            total={Number(sent)}
            value={Number(bounceCount)}
          />
          <PercentageItem
            title="Unsubscribe"
            total={Number(sent)}
            value={Number(unsubscriptionCount)}
          />
        </Row>
      </Spin>
    </div>
  );
}
